import type { Timestamp } from "firebase/firestore";
import { IVehicle } from "./user";
import type { ICustomer, IRemark } from "./case";
import { IPayment } from "./case";
import type { ICoord } from "./information";
import type { ICaseWorkshopRef } from "./client-email";

// Status enum (matching EStatus pattern)
export enum ECaseRequestStatus {
  CREATED = "created",
  IN_PROGRESS = "in_progress",
  WAITING_CUSTOMER = "waiting_customer",
  CANCELLED = "cancelled",
  ACCEPTED = "accepted",
}

export enum ECaseRequestStatusText {
  CREATED = "Created",
  IN_PROGRESS = "In Progress",
  WAITING_CUSTOMER = "Waiting Customer",
  CANCELLED = "Cancelled",
  ACCEPTED = "Accepted",
}

export interface ICaseRequest {
  // ===== REQUEST-SPECIFIC METADATA =====

  id: string;
  caseId?: string;
  caseRegNum?: string;
  companyId?: string;
  sourceCompanyName?: string;
  createdBy: string;
  updatedBy: string;
  status: ECaseRequestStatus;

  // Request-specific workflow
  assignedTo?: string;
  policeReport?: boolean;
  basementTowing?: boolean;
  program?: string;

  // Timestamps
  timestamps: {
    createdAt: Timestamp | Date;
    updatedAt: Timestamp | Date;
    assignedAt?: Timestamp | Date;
    notifiedAt?: Timestamp | Date;
    confirmedAt?: Timestamp | Date;
    estimatedArrivalAt?: Timestamp | Date;
  };

  // ===== IDENTICAL TO CASE =====

  customer: ICustomer;
  policyType?: string;
  policyId?: string;

  location: {
    from: {
      coord: ICoord;
      address: string;
      generatedAddress: string;
    };
    to: {
      coord: ICoord;
      address: string;
      generatedAddress: string;
      // Set when the destination was picked from the client company's workshops
      workshop?: ICaseWorkshopRef | null;
    };
    distance: number;
    state: string[];
    city: string;
  };

  choosedService: string[];

  remarks: {
    external: IRemark[];
    internal: IRemark[];
  };

  // Firebase Storage download URLs attached at creation (mobile app only)
  images?: string[];

  // Mobile-app service category: "towing" | "roadside_assist"
  category?: string;
}

// For list display
export interface ICaseRequestSummary {
  id: string;
  timestamps: {
    createdAt: Timestamp | Date;
  };
  status: ECaseRequestStatus;
  location: {
    from: {
      address: string;
    };
  };
  customer: {
    name: string;
    vehicle: {
      regNum: string;
    };
  };
  caseId?: string;
  caseRegNum?: string;
}
